// src/pages/ForIndependentPractices.js
import React from 'react';
import Header from '../components/Header';
import '../components/ComprehensiveSection';
import '../components/Footer';
import ImageUrl from '../assets/automate_your_practice.jpg';
import ComprehensiveSection from '../components/ComprehensiveSection';
import Footer from '../components/Footer';
import Solutions from '../components/Solutions';
import forIndependentSolutionsData from '../components/forIndependentSolutionsData';
import CategoryExperience from '../components/CategoryExperience';
//import Resources from '../components/Resources';
import CallToAction from '../components/CallToAction';
import logo1 from '../assets/emr.png';
import logo2 from '../assets/digital-footprint.png';
import logo3 from '../assets/digital-outreach.png';
import logo4 from '../assets/billing-and-payments.png';
import logo5 from '../assets/data-and-insights.png';
import { Helmet } from 'react-helmet';


const ForIndependentPractices = () => {

  //passing data dynamically to comprehensive section
  const blockData = [
    {
      logo: logo1,
      title: 'EMR',
      text: 'Experience a certified EHR solution offering robust charting, documentation, patient histories, eRx, eLabs, telehealth, and customizable care delivery.',
      link: '/emr',
    },
    {
      logo: logo2,
      title: 'Digital Footprint',
      text: 'Expand your practice with secure websites, expert SEO, search marketing tools, reputation management, web profiles, and social media management.',
      link: '/digital-footprint',
    },
    {
      logo: logo3,
      title: 'Digital Outreach',
      text: 'Expand your reach through search marketing tools, automated reputation management, polished web profiles, and effective social media management.',
      link: '/digital-outreach',
    },
    {
      logo: logo4,
      title: 'Billing & Payments',
      text: 'Enroll, submit, and track on a unified platform. Gain financial visibility with reporting, analytics, automation, and streamlined payment methods for faster collections.',
      link: '/billing-and-payments',
    },
    {
      logo: logo5,
      title: 'Data & Insights',
      text: 'Get deeper insights of your practice growth, patient revenue with Doclivo analytics. Unlock valuable data and insights to drive informed decisions and improve performance.',
      link: '/data-and-insights',
    },
  ];

  return (
    <div>
      <Helmet>
          <title> ForIndependentPractices - Doclivo</title>
          <meta name="description" content="Learn more about Your Company Name, the leading provider of automation and optimization solutions." />
          <meta name="keywords" content="about us, company, automation" />
        </Helmet>
      <Header
        title="Your all-in-one platform for all practice requirements"
        subtitle="Discover a suite of digital tools and support tailored to assist independent practices in attracting new patients, delivering modern care, facilitating prompt payments, and operating efficiently."
        imageUrl={ImageUrl}
        buttonText="Request Demo"
        secondaryButtonText="Learn More" // This won't be displayed
        showSecondaryButton={false} // Show only the primary button
      />
      {/* Other components specific to this page */}

      <Solutions
        solutionsData={forIndependentSolutionsData}
        sectionTitle="Empowering independent practices to thrive."
        showButton={false}
      >
      </Solutions>

      <CategoryExperience></CategoryExperience>
      <ComprehensiveSection blockData={blockData} />
      {/* <Resources></Resources> */}
      <CallToAction></CallToAction>
      <Footer></Footer>
    </div>
  );
};

export default ForIndependentPractices;
